
<div class="header-frame" id="header">
    
<div class="header-cont">
    <img class="logo" src="assets/images/favicon.png" alt="">
    <div class="burger-frame">
        <img src="assets/icons/burger-menu-50-white.png" alt="burger" (click)="toggleNavigation()">
    </div>
</div>
</div>
